module.exports = __webpack_public_path__ + "img/toxis-1.9d8037a6.jpg";